"use client";
import * as React from "react";
const SvgManualGearSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h1.83v5.44H6.4V0h1.83v5.44h4.57V0h1.83v7.25h-6.4v5.44H6.4V7.25H1.83v5.44H0zm15.18 12.69H16V9.06h-4.57v5.44h1.37v-1.81h1l.83 1.81H16zm-.55-2.27v.9H12.8v-.9z", clipRule: "evenodd" }));
export {
  SvgManualGearSharp as default
};
